<template>
  <div>
    <base-data-table
      :loading="isLoading"
      :headers="headers"
      :items="groups.data"
      :serverItemsLength="groups.total"
      :nbItemsByPage="NB_ITEMS_BY_PAGE"
      :options.sync="options"
      containerId="#table-groupes-container"
      itemClickRouterTarget="groupe-details"
      :fixedHeaders="fixedHeaders"
      class="table-cursor"
    >
      <template v-slot:item.portal="{ item }">
        <span v-if="item.portal == 3">v5</span>
        <span v-else-if="item.portal == 2">v4</span>
        <span v-else-if="item.portal == 1">v3</span>
        <span v-else>v2</span>
      </template>

      <template v-slot:item.updatedAt="{ item }">
        {{ getInternationalDate(item.updatedAt) }}
      </template>
    </base-data-table>
  </div>
</template>
<script>
import { date } from "@/composables/date";
import { onMounted, toRefs, watch } from "@vue/composition-api";
import { useGroup } from "../../composables/group";
import BaseDataTable from "@/components/General/BaseDataTable.vue";

export default {
  components: {
    BaseDataTable,
  },
  props: {
    criteria: Object,
    fixedHeaders: { type: Boolean, default: true },
  },
  setup(props, { emit }) {
    /* Import des API */
    const { getInternationalDate } = date();
    const { data, listGroups } = useGroup();

    /* Variables */
    const NB_ITEMS_BY_PAGE = 100;

    /* Cycle de vie */
    onMounted(async () => {
      await listGroups(props.criteria);
      emit("display:nb-groups", data.groups.total);
    });

    /* Watchers */
    watch(
      () => props.criteria,
      async () => {
        if (
          props.criteria.name.length > 1 ||
          props.criteria.name.length == 0 ||
          props.criteria.versions.length > 0
        ) {
          await listGroups(props.criteria);
          emit("display:nb-groups", data.groups.total);
        }
      },
      { deep: true }
    );
    watch(
      () => data.options,
      async (newValue, oldValue) => {
        if (oldValue.page !== undefined) {
          await listGroups(props.criteria);
          emit("display:nb-groups", data.groups.total);
        }
      },
      {
        deep: true,
      }
    );

    return {
      ...toRefs(data),
      getInternationalDate,
      headers: [
        { text: "Nom", value: "description" },
        { text: "Id", value: "id" },
        { text: "Nb portails", value: "nbClientPortals", sortable: false },
        {
          text: "Portails hérités",
          value: "nbInheritedClientPortals",
          sortable: false,
        },
        {
          text: "Portails actifs",
          value: "nbActiveClientPortals",
          sortable: false,
        },
        { text: "Version", value: "portal" },
        { text: "Dernier éditeur", value: "updatedBy" },
        { text: "Date", value: "updatedAt" },
      ],
      NB_ITEMS_BY_PAGE,
    };
  },
};
</script>
<style scoped>
.table-cursor::v-deep tbody {
  cursor: pointer;
}
</style>
